import React from 'react';
import PropTypes from 'prop-types';
import s from './Keyhighlights.scss';

class Keyhighlights extends React.PureComponent {
  getHighLightsHtml = () => {
    const isHighlightPresent =
      this.props.highlight && this.props.highlight.length > 0;
    const isHighlightCdataPresent =
      this.props.highlightCdata && this.props.highlightCdata.length > 0;
    if (isHighlightPresent) {
      return (
        <ul>
          {this.props.highlight.map((value, index) => (
            // eslint-disable-next-line react/no-danger
            <li key={index} dangerouslySetInnerHTML={{ __html: value }} />
          ))}
        </ul>
      );
    } else if (isHighlightCdataPresent) {
      return (
        <div
          className={s.cDataDiv}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: unescape(this.props.highlightCdata[0]),
          }}
        />
      );
    }

    return null;
  };

  render() {
    const isHighlighPresent =
      (this.props.highlight && this.props.highlight.length > 0) ||
      (this.props.highlightCdata && this.props.highlightCdata.length > 0);
    if (!isHighlighPresent) {
      return null;
    }
    return (
      isHighlighPresent && (
        <>
          <div
            className={`${s.highlights} ${
              this.props.nic ? s.nic : 'id-r-highlights'
            }`}
          >
            <div className={s.doubledot_heading}>
              <i />
              <span>Key Highlights</span>
            </div>
            {this.getHighLightsHtml()}
          </div>
        </>
      )
    );
  }
}
Keyhighlights.propTypes = {
  highlight: PropTypes.arrayOf(PropTypes.string),
  highlightCdata: PropTypes.arrayOf(PropTypes.string),
  nic: PropTypes.bool,
};
Keyhighlights.defaultProps = {
  highlight: [],
  highlightCdata: [],
  nic: false,
};

export default Keyhighlights;
